var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
import { FiltersComponent } from '../filters.component';
import { debounceTime } from 'rxjs/operators';
import { UpdatedSince } from "../../../classes/enums";
var FiltersCommercialComponent = /** @class */ (function (_super) {
    __extends(FiltersCommercialComponent, _super);
    function FiltersCommercialComponent(preferencesService, communicationService, translateService, router, listingsService, fb, cd) {
        var _this = _super.call(this, preferencesService, communicationService, translateService, router, fb, cd) || this;
        _this.preferencesService = preferencesService;
        _this.communicationService = communicationService;
        _this.translateService = translateService;
        _this.router = router;
        _this.listingsService = listingsService;
        _this.fb = fb;
        _this.cd = cd;
        _this.showListingTypes = false;
        _this.showAllListingTypes = false;
        _this.showBusinessTypes = false;
        _this.showAllBusinessTypes = true;
        _this.businessType = [];
        _this.listingType = [
            'commercial',
            'farm',
            'businessOpportunity',
            'hotelResort',
            'commercialLease',
            'vacantLand'
        ];
        _this.priceOptions = [
            { key: 'filters.primary-price', value: 0 },
            { key: 'filters.per-sqft', value: 1 }
        ];
        _this.pricePerSqftValues = Array.apply(null, { length: 21 }).map(function (a, b) { return b * 5; });
        _this.sqftOptions = [
            { key: 'filters.square-feet', value: {}, disabled: true },
            { key: 'filters.any', value: {} },
            { text: '100+', value: { min: 100 } },
            { text: '1,000+', value: { min: 1000 } },
            { text: '10,000+', value: { min: 10000 } },
            { text: '1,000,000+', value: { min: 1000000 } }
        ];
        _this.storiesOptions = [
            { key: 'filters.stories', value: {}, disabled: true },
            { key: 'filters.any', value: {} },
            { text: '2+', value: { min: 2 } },
            { text: '10+', value: { min: 10 } },
            { text: '100+', value: { min: 100 } }
        ];
        _this.unitsOptions = [
            { key: 'filters.units', value: {}, disabled: true },
            { key: 'filters.any', value: {} },
            { text: '10+', value: { min: 10 } },
            { text: '100+', value: { min: 100 } },
            { text: '1,000+', value: { min: 1000 } }
        ];
        _this.totalAcresOptions = [
            { key: 'filters.land-size', value: {}, disabled: true },
            { key: 'filters.any', value: {} },
            { text: '100+', value: { min: 100 } },
            { text: '1,000+', value: { min: 1000 } },
            { text: '10,000+', value: { min: 10000 } }
        ];
        _this.parkingOptions = [
            { key: 'filters.parking-spaces', value: {}, disabled: true },
            { key: 'filters.any', value: {} },
            { text: '1', value: { min: 1, max: 1 } },
            { text: '2+', value: { min: 2 } },
            { text: '5+', value: { min: 5 } },
            { text: '10+', value: { min: 10 } },
            { text: '100+', value: { min: 100 } },
            { text: '1,000+', value: { min: 1000 } }
        ];
        var listingTypesControls = _this.filtersForm.controls['listingTypes'];
        _this.listingType.forEach(function (it) {
            listingTypesControls.addControl(it, _this.fb.control(false));
        });
        _this.filtersForm.addControl('stories', _this.fb.control({}));
        _this.filtersForm.addControl('size', _this.fb.control({}));
        _this.filtersForm.addControl('units', _this.fb.control({}));
        _this.filtersForm.addControl('sqft', _this.fb.control({}));
        _this.filtersForm.addControl('totalAcres', _this.fb.control({}));
        _this.filtersForm.addControl('parking', _this.fb.control({}));
        _this.filtersForm.addControl('priceType', _this.fb.control(0));
        return _this;
    }
    FiltersCommercialComponent.prototype._updateFiltersForm = function (filters) {
        this.filters = filters;
    };
    FiltersCommercialComponent.prototype.ngOnInit = function () {
        var _this = this;
        _super.prototype.ngOnInit.call(this);
        this.addSub(this.listingsService.getFilters().subscribe(function (result) {
            _this.addBusinessTypes(result);
        }));
        this.addSub(this.listingTypesFg.valueChanges.pipe(debounceTime(10)).subscribe(function (s) {
            _this.showAllListingTypes = Object.keys(s).every(function (k) { return !s[k]; });
        }));
        this.addSub(this.filtersForm.controls['priceType'].valueChanges.pipe(debounceTime(10)).subscribe(function (s) {
            var minValueToSet = 0;
            var maxValueToSet = 0;
            _this.isPricePerSqft = s === 1;
            if (_this.isPricePerSqft) {
                if (_this.filters.pricePerSqFt) {
                    minValueToSet = _this.filters.pricePerSqFt.min;
                    maxValueToSet = _this.filters.pricePerSqFt.max;
                }
            }
            else if (_this.filters.price) {
                minValueToSet = _this.filters.price.min;
                maxValueToSet = _this.filters.price.max;
            }
            _this.filtersForm.controls['minPrice'].setValue(minValueToSet || 0);
            _this.filtersForm.controls['maxPrice'].setValue(maxValueToSet || 0);
            _this.filtersForm.controls['updatedSince'].setValue(UpdatedSince.ANY);
        }));
    };
    FiltersCommercialComponent.prototype.onReset = function () {
        _super.prototype.onReset.call(this);
        this.filtersForm.controls['stories'].setValue({});
        this.filtersForm.controls['size'].setValue({});
        this.filtersForm.controls['units'].setValue({});
        this.filtersForm.controls['totalAcres'].setValue({});
        this.filtersForm.controls['parking'].setValue({});
        this.filtersForm.controls['sqft'].setValue({});
        this.filtersForm.controls['updatedSince'].setValue(UpdatedSince.ANY);
    };
    FiltersCommercialComponent.prototype.clearBusinessTypes = function () {
        var businessTypeForm = this.businessTypesFg;
        this.businessType.forEach(function (it) {
            businessTypeForm.get(it).patchValue(false);
        });
    };
    FiltersCommercialComponent.prototype.clearListingTypes = function () {
        var listingTypeForm = this.listingTypesFg;
        this.listingType.forEach(function (it) {
            listingTypeForm.get(it).patchValue(false);
        });
    };
    /**
     * iterate through the business types received from the server and add controls to the form group
     * @param result
     */
    FiltersCommercialComponent.prototype.addBusinessTypes = function (result) {
        var _this = this;
        this.businessType = result;
        var businessTypesControls = this.fb.group({});
        this.businessType.forEach(function (it) {
            businessTypesControls.addControl(it, _this.fb.control(false));
        });
        this.filtersForm.addControl('businessTypes', businessTypesControls);
        this.addSub(this.businessTypesFg.valueChanges.pipe(debounceTime(10)).subscribe(function (s) {
            _this.showAllBusinessTypes = Object.keys(s).every(function (k) { return !s[k]; });
        }));
        // map the filters retrieved from the local storage to the form group
        if (this.filters.businessTypes) {
            Object.keys(this.filters.businessTypes).forEach(function (key) {
                var control = businessTypesControls.get(key);
                if (control) {
                    control.patchValue(_this.filters.businessTypes[key]);
                }
            });
        }
        if (this.filters.listingTypes) {
            Object.keys(this.filters.listingTypes).forEach(function (key) {
                var control = _this.listingTypesFg.get(key);
                if (control) {
                    control.patchValue(_this.filters.listingTypes[key]);
                }
            });
        }
        this.filtersForm.patchValue({
            sqft: this.filters.sqft,
            stories: this.filters.stories,
            size: this.filters.size,
            units: this.filters.units,
            totalAcres: this.filters.totalAcres,
            parking: this.filters.parking,
            priceType: this.filters.priceType ? this.filters.priceType : 0,
            price: this.filters.priceType === 1 ? { min: this.filters.pricePerSqFt.min, max: this.filters.pricePerSqFt.max } : { min: this.filters.price.min, max: this.filters.price.max },
            updatedSince: this.filters.updatedSince
        });
    };
    Object.defineProperty(FiltersCommercialComponent.prototype, "businessTypesFg", {
        get: function () {
            return this.filtersForm.get('businessTypes');
        },
        enumerable: true,
        configurable: true
    });
    return FiltersCommercialComponent;
}(FiltersComponent));
export { FiltersCommercialComponent };
